import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { BillingPlanTier } from '@recruitee/http/types';

@Component({
  selector: 'rt-feature-button',
  template: `<rt-plan-button
    [variant]="
      $any(
        plan &&
          [
            BillingPlanTier.Lead,
            BillingPlanTier.Scale,
            BillingPlanTier.Grow,
            BillingPlanTier.Optimize
          ].includes(plan)
          ? plan
          : 'secondary'
      )
    "
    (click)="openPlanPicker.emit()"
    ><ng-content></ng-content
  ></rt-plan-button>`,
  styleUrls: ['./feature-button.component.less'],
  host: {
    '[class]': '"plan-"+ plan',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FeatureButtonComponent {
  @Input() public plan: BillingPlanTier | null;
  @Output() public openPlanPicker: EventEmitter<void> = new EventEmitter<void>();

  public BillingPlanTier: typeof BillingPlanTier = BillingPlanTier;
}
